package com.essntl.features.paymentparameter.ui.addeditpaymentparameter

import core.validation.Form
import core.validation.field.Field
import core.validation.field.StringField
import core.validation.validator.NonEmptyValidator

class AddEditPaymentParameterValidation {
    val addEditPaymentParameterForm = AddEditPaymentParameterForm()
}

class AddEditPaymentParameterForm : Form() {
    val name =
        StringField(NonEmptyValidator)

    val amount =
        StringField(NonEmptyValidator)

    override val fields: List<Field> =
        listOf(
            name,
            amount,
        )
}